module.exports = __webpack_public_path__ + "static/media/sector2.3c68951c.svg";